import { Link } from 'react-router-dom';
import { PUBLIC_CONTAINER } from '@/components/PublicContainer';

/**
 * Reusable footer for the logged-out / public experience. Institutional column layout.
 * Renders on the homepage, public marketing/auth pages, the new public content pages,
 * and the /terms and /privacy legal pages. Same-tab internal navigation. No dead links.
 */
const COLUMNS = [
  {
    heading: 'SERGEANT TAP',
    links: [
      { label: 'About', to: '/about' },
      { label: 'Why Sergeant TAP', to: '/#why-sergeant-tap' },
      { label: 'News & Research', to: '/news-research' },
      { label: 'Contact', to: '/contact' },
    ],
  },
  {
    heading: 'FOR YOU',
    links: [
      { label: 'Service Members', to: '/#service-members' },
      { label: 'Employers', to: '/#employers' },
      { label: 'Communities', to: '/#communities' },
    ],
  },
  {
    heading: 'RESOURCES',
    links: [
      { label: 'News & Research', to: '/news-research' },
    ],
  },
  {
    heading: 'LEGAL',
    links: [
      { label: 'Privacy Policy', to: '/privacy' },
      { label: 'Terms of Service', to: '/terms' },
    ],
  },
];

const slugify = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');

export const PublicFooter = ({ footerText = '' }) => (
  <footer data-testid="public-footer" className="bg-white border-t border-[#e5e5e5] pt-10 pb-8">
    <div className={PUBLIC_CONTAINER}>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
        {COLUMNS.map((col) => (
          <div key={col.heading} data-testid={`footer-col-${slugify(col.heading)}`}>
            <h3 className="text-xs font-bold tracking-wider text-slate-900 mb-3">{col.heading}</h3>
            <ul className="space-y-2">
              {col.links.map((l) => (
                <li key={l.label}>
                  <Link
                    to={l.to}
                    data-testid={`footer-link-${slugify(l.label)}`}
                    className="text-sm text-[#666] hover:text-brand transition-colors"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div className="mt-10 pt-6 border-t border-[#eee] flex flex-col sm:flex-row items-center justify-between gap-3">
        <img src={`${process.env.PUBLIC_URL}/sergeant-tap-logo.png`} alt="Sergeant TAP" className="h-7 w-auto object-contain" />
        <p className="text-xs text-[#999] text-center">
          &copy; {new Date().getFullYear()} Sergeant TAP. {footerText}
        </p>
      </div>
    </div>
  </footer>
);

export default PublicFooter;
